<template lang="pug">
  div(:class="b()")
    .space-bottom.big-title Más de 50.000 solicitudes y USD$ 40MM de hipotecas originadas.
    ul
      li Préstamos desde S/.20,000
      li Tasa desde 1.6% mensual
</template>

<script>
  export default {
    name: 'trust-loans',
  };
</script>
